import _ from 'lodash'

class subscriptionHelpOffreRentree2018Ctrl {
    /** @ngInject */
    constructor($stateParams, ContactTelephone) {
        this.$stateParams = $stateParams
        this.ContactTelephone = ContactTelephone
        this.logoMapping = {
            'aix': 'logo-aix.svg',
            'le mans': 'logo-le-mans.svg',
            'montpellier': 'logo-montpellier.svg',
            'nancy': 'logo-nancy.svg',
            'nantes': 'logo-nantes.svg',
            'nice': 'logo-nice.svg',
            'nimes': 'logo-nimes.svg',
            'nîmes': 'logo-nimes.svg',
            'perpignan': 'logo-perpignan.svg',
            'toulon': 'logo-toulon.svg',
            'toulouse': 'logo-toulouse.svg',
        }
    }

    $onInit() {
        this.logo = _.get(this.logoMapping, _.toLower(this.$stateParams.ville), 'logo-ag-hcplus.svg')
    }
}

export default {
    template: require('./subscriptionHelpOffreRentree2018.jade')(),
    controller: subscriptionHelpOffreRentree2018Ctrl,
    bindings: {
        contractDraft: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/subscription/component/subscriptionHelpOffreRentree2018.js